import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";
import { useAuthContext } from '../hooks/useAuthContext';
import DetailsModal from "../components/modals/SO Modals/SODetailsModal";
import EditSOModal from '../components/modals/SO Modals/EditSOModal';
import CreateSOModal from '../components/modals/SO Modals/CreateSOModal';

const SaleOrdersPage = () => {
    const [watches, setWatches] = useState(); //watches variable will hold all active sales orders returned from API call to DB
    const [selectedWatch, setSelectedWatch] = useState();
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [error, setError] = useState(null);
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook


    //get screensize
    const getScreenSize = () => {
        const width = window.innerWidth;
        if (width < 500) return 'xsmall';
        if (width >= 500 && width < 800) return 'small';
        if (width >= 800 && width < 1440) return 'medium';
        return 'large';
    };
    const [screenSize, setScreenSize] = useState(getScreenSize());



    useEffect(() => {
        const getRequests = async () => {
            try {
                const response = await axios.get(
                    // eslint-disable-next-line
                    process.env.REACT_APP_SERVER_URL + '/api/saleOrders' + `?month=${month}&year=${year}`, 
                    {headers: {'Authorization': `Bearer ${user.token}`}}
                ); //get all active sale orders

                setWatches(response.data);
            } catch (error) {
                console.error('Failed to get all watch requests: ' + error.message);
            }
        }

        if (user) {
            getRequests();
        }

        const handleResize = () => {
            setScreenSize(getScreenSize());
          };
      
        window.addEventListener('resize', handleResize);
      
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [user, month, year]);



    const createInvoice = async (watch) => {
        const request = {
            brand: watch.brand, 
            model: watch.model, 
            year: watch.year, 
            saleDate: watch.saleOrder.saleDate.slice(0,10), 
            salePrice: watch.saleOrder.salePrice, 
            saleCustomer: watch.saleOrder.saleCustomer, 
            shipToStreet: watch.saleOrder.shipToStreet, 
            shipToCity: watch.saleOrder.shipToCity, 
            shipToState: watch.saleOrder.shipToState, 
            shipToZip: watch.saleOrder.shipToZip,
            userId: user.userId
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/api/invoice/create-invoice`,
                request,
                {
                    responseType: 'blob',
                    headers: {'Authorization': `Bearer ${user.token}`}
                }
            )

            const file = new Blob([response.data], { type: 'application/pdf' });

            // Create a URL for the Blob
            const url = window.URL.createObjectURL(file);

            // Optionally, open in a new window
            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write('<iframe width="100%" height="100%" src="' + url + '"></iframe>');
            }
        } catch (error) {
            setError(error.message);
        }
    }


    //modal functions
    const details = (watch) => {
        setOpenDetailsModal(true);
        setSelectedWatch(watch);
    }
    const closeDetails = () => {
        setOpenDetailsModal(false);
    }

    const edit = (watch) => {
        setOpenEditModal(true);
        setSelectedWatch(watch);
    }
    const closeEdit = () => {
        setOpenEditModal(false);
    }

    const create = () => {
        setOpenCreateModal(true);
    }
    const closeCreate = () => {
        setOpenCreateModal(false);
    }




    return(
        <div className="saleorder-table-container">
            {/* Details Modal */}
            <Modal
                isOpen={openDetailsModal}
                onRequestClose={closeDetails}
                contentLabel="Sale Order Details"
            >
                <div className="modal-header">
                    <h2>Watch Details</h2>
                    <button className="btn btn-light" onClick={closeDetails}>Close</button>
                </div>
                <DetailsModal watch={selectedWatch}/>
            </Modal>

            {/* Edit SO Modal */}
            <Modal
                isOpen={openEditModal}
                onRequestClose={closeEdit}
                contentLabel="Edit Sale Order"
            >
                <div className="modal-header">
                    <h2>Edit Inventory</h2>
                    <button className="btn btn-light" onClick={closeEdit}>Close</button>
                </div>
                <EditSOModal watch={selectedWatch}/>
            </Modal>

            {/* Create SO Modal */}
            <Modal
                isOpen={openCreateModal}
                onRequestClose={closeCreate}
                contentLabel="Create Sale Order"
            >
                <div className="modal-header">
                    <h2>Create Sale Order</h2>
                    <button className="btn btn-light" onClick={closeCreate}>Close</button>
                </div>
                <CreateSOModal />
            </Modal>

            <div className="top-banner">
                <h2>Sale Orders - {month}/{year-2000}</h2>
                <button className="btn btn-light" onClick={create}><i className="fa-regular fa-plus"></i>Create Sale Order</button>
            </div>

            <div className="sales-filters">
                <select
                        className="form-select"
                        onChange={(event) => setMonth(event.target.value)}
                        value={month} 
                    > 
                        <option value='1'>Jan</option>
                        <option value="2">Feb</option>
                        <option value="3">Mar</option>
                        <option value="4">Apr</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">Aug</option>
                        <option value="9">Sep</option>
                        <option value="10">Oct</option>
                        <option value="11">Nov</option>
                        <option value="12">Dec</option>
                    </select>
                    <select
                        className="form-select"
                        onChange={(event) => setYear(event.target.value)}
                        value={year} 
                    > 
                        <option value='2024'>2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2028">2027</option>
                        <option value="2028">2028</option>
                    </select>
            </div>

            <table className="saleorder-table table">
                <thead>
                    <tr>
                        <th>Details</th>
                        {screenSize !== 'xsmall' && <th>Sale Date</th>}
                        {screenSize !== 'xsmall' && screenSize !== 'small' && <th>Customer</th>}
                        {screenSize !== 'xsmall' && screenSize !== 'small' && <th>Brand</th>}
                        <th>Model</th>
                        {screenSize === 'large' && <th>Year</th>}
                        {screenSize === 'large' && <th>Ref. #</th>}
                        {screenSize !== 'xsmall' && screenSize !== 'small' && <th>Sale Price</th>}
                        {screenSize !== 'xsmall' && screenSize !== 'small' && <th>Invoice</th>}
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {watches && watches.map((watch) => (
                        <tr key={watch._id}>
                            <td><button className='btn' onClick={() => details(watch)}><i className="fa-regular fa-eye"></i></button></td>
                            {screenSize !== 'xsmall' && <td>{watch.saleOrder.saleDate.slice(0,10)}</td>}
                            {screenSize !== 'xsmall' && screenSize !== 'small' && <td>{watch.saleOrder.saleCustomer}</td>}
                            {screenSize !== 'xsmall' && screenSize !== 'small' && <td>{watch.brand}</td>}
                            <td>{watch.model}</td>
                            {screenSize === 'large' && <td>{watch.year}</td>}
                            {screenSize === 'large' && <td>{watch.refNum}</td>}
                            {screenSize !== 'xsmall' && screenSize !== 'small' && <td>${watch.saleOrder.salePrice}</td>}
                            {screenSize !== 'xsmall' && screenSize !== 'small' && 
                            <td>
                                <button className="btn" onClick={() => createInvoice(watch)}>
                                    <i className="fa-solid fa-file-invoice"></i>
                                </button>
                            </td>}
                            <td><button className='btn' onClick={() => edit(watch)}><i className="fa-solid fa-pen"></i></button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {error && <div className="error">{error}</div>}
        </div>
    )
}

export default SaleOrdersPage;